/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AppLabInfo } from '../../models/app-lab-info';

export interface LabControllerFindSupportedLabList$Params {
}

export function labControllerFindSupportedLabList(http: HttpClient, rootUrl: string, params?: LabControllerFindSupportedLabList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AppLabInfo>>> {
  const rb = new RequestBuilder(rootUrl, labControllerFindSupportedLabList.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AppLabInfo>>;
    })
  );
}

labControllerFindSupportedLabList.PATH = '/lab/supportedList';
